import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { PackagingWarehouseInstructionsFormValues } from "../schemas"

import { FormTextField } from "@/components/UiKit"

const fieldStyles = {
  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },
}

export const PackagingWarehouseInstructionsForm: FC = () => {
  const { control } = useFormContext<PackagingWarehouseInstructionsFormValues>()

  return (
    <div className='flex flex-col gap-y-6'>
      <FormTextField
        control={control}
        name='bolNotes'
        label='BoL Notes'
        placeholder='Add special packaging notes...'
        multiline
        minRows={3}
        sx={fieldStyles}
        data-testid='customer-product.packaging-warehouse-form-dialog.bol-notes-field'
      />
      <FormTextField
        control={control}
        name='warehouseInstructions'
        label='Warehouse Instructions'
        placeholder='Add pick / stage / ship notes...'
        multiline
        minRows={3}
        sx={fieldStyles}
        data-testid='customer-product.packaging-warehouse-form-dialog.warehouse-instructions-field'
      />
    </div>
  )
}
